<script>
import RexButton from '@/rex-components/rex-button.vue';
import {
  VIEW_GROK_TAB_KEY,
  VIEW_LOGS_TAB_KEY,
  VIEW_SAVED_SEARCHES_TAB_KEY,
} from '@/components/Log/log.constants';
import { getRouteName } from '@/components/Log/log.types';
import { mapState } from 'vuex';

export default {
  components: {
    RexButton,
  },
  computed: {
    ...mapState('logState/logCommonState', ['isADType']),
    viewLogs() {
      return (
        this.$route.query.currView !== VIEW_GROK_TAB_KEY &&
        this.$route.query.currView !== VIEW_SAVED_SEARCHES_TAB_KEY
      );
    },
    viewGrok() {
      return this.$route.query.currView === VIEW_GROK_TAB_KEY;
    },
    viewSavedSearch() {
      return this.$route.query.currView === VIEW_SAVED_SEARCHES_TAB_KEY;
    },
    viewLogsClass() {
      return this.getBtnClass(
        this.getBtnVariant(this.viewLogs) === 'secondary',
      );
    },
    viewGrokClass() {
      return this.getBtnClass(
        this.getBtnVariant(this.viewGrok) === 'secondary',
      );
    },
    viewSavedSearchClass() {
      return this.getBtnClass(
        this.getBtnVariant(this.viewSavedSearch) === 'secondary',
      );
    },
  },
  data() {
    return {
      disableBtn: false,
    };
  },
  methods: {
    changeView(currView) {
      if (this.disableBtn) return;
      this.$router.push({
        name: getRouteName(this.isADType),
        query: { ...this.$route.query, currView },
      });
    },
    getBtnVariant(viewBtn) {
      return viewBtn && this.disableBtn
        ? 'disabled'
        : viewBtn
          ? 'primary'
          : 'secondary';
    },
    getBtnClass(isSecondary) {
      return !isSecondary
        ? ''
        : this.disableBtn
          ? 'font-primary-disable-cursor'
          : 'font-primary';
    },
  },
  watch: {
    '$route.query.queryExec': {
      immediate: true,
      handler(newValue) {
        this.disableBtn = newValue?.length > 0;
      },
    },
  },
  created() {
    this.viewLogsKey = VIEW_LOGS_TAB_KEY;
    this.viewGrokKey = VIEW_GROK_TAB_KEY;
    this.viewSavedSearchKey = VIEW_SAVED_SEARCHES_TAB_KEY;
  },
};
</script>

<template>
  <div>
    <RexButton
      class="log-view-tab-btn"
      :class="viewLogsClass"
      :variant="getBtnVariant(viewLogs)"
      :styling="{ width: '11.5rem' }"
      id="log-actions-bar-view-logs-btn"
      @onClick="() => changeView(viewLogsKey)"
    >
      {{ isADType ? $t('analytics.viewAnalytics') : $t('log.viewLogs') }}
    </RexButton>
    <RexButton
      class="log-view-tab-btn"
      :class="viewGrokClass"
      :variant="getBtnVariant(viewGrok)"
      :styling="{ width: '11.5rem' }"
      id="log-actions-bar-view-grok-btn"
      @onClick="() => changeView(viewGrokKey)"
      v-if="!isADType"
    >
      {{ $t('log.viewGrokPatterns') }}
    </RexButton>
    <RexButton
      class="log-view-tab-btn"
      :class="viewSavedSearchClass"
      :variant="getBtnVariant(viewSavedSearch)"
      :styling="{ width: '11.5rem' }"
      id="log-actions-bar-view-saved-search-btn"
      @onClick="() => changeView(viewSavedSearchKey)"
    >
      {{ $t('log.viewSavedSearches') }}
    </RexButton>
  </div>
</template>

<style lang="scss" scoped>
.log-view-tab-btn {
  @include dropshadow-effect($opacity: 0);
  font-size: 1rem;
  padding: 0rem;
  border-top: solid 0.0625em $border-primary;
  border-bottom: solid 0.0625em $border-primary;
  border-left: solid 0.0625em $border-primary;
  border-right: 0rem;
  border-radius: 0rem;
}
.log-view-tab-btn:first-child {
  border-top-left-radius: 0.25em;
  border-bottom-left-radius: 0.25em;
}
.log-view-tab-btn:last-child {
  border-top-right-radius: 0.25em;
  border-bottom-right-radius: 0.25em;
  border-right: solid 0.0625em $border-primary;
}
.font-primary:hover {
  color: $color-brand-accent;
}
.font-primary {
  color: $font-primary;
}

.font-primary-disable-cursor {
  color: $font-primary;
  pointer-events: none;
  cursor: not-allowed !important;
}
</style>
